import {Component} from '@angular/core';
import {RouterOutlet} from "@angular/router";

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent {

}
